import { z } from 'zod';

/**
 * No compiled validators: zod otherwise probes `new Function()`, which the SPA's CSP
 * (no 'unsafe-eval') refuses and reports as a console error.
 */
z.config({ jitless: true });
